import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ParameterTypeEnum } from '@commons/enums/parameter-type.enum';
import { Vehicle } from '@commons/models/domain/Vehicle';

@Component({
  selector: 'app-singal-status',
  templateUrl: './gps-status.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styles: [`
    ::ng-deep {
        .p-progressbar {
            height: 4px;
        }
        .p-progressbar-determinate .p-progressbar-value-animate {
          transition: none !important;
        }
    }
  `]
})
export class SingalStatusComponent {

  @Input('data') set data(value: Vehicle) {
    setTimeout(() => {
      this.calculate(value);
    }, 0);
  }
  @Input() public parameterType: ParameterTypeEnum;
  @Input() public scaleMax: number;

  public value: number = 0;

  constructor() { }

  private calculate(data: Vehicle): void {
    const control = data.ControlIndicators?.find(p => p && p.Tp === this.parameterType);
    if (control) {
      this.value = this.calculatePercentge(this.scaleMax, control?.LV?.V);
    }
  }

  private calculatePercentge(total: number, currentValue: number): number {
    return (currentValue / total) * 100;
  }

}
